var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.82 10.1725L11.1267 9.97919C10.72 9.93253 10.32 10.0725 10.0334 10.3592L8.80669 11.5859C6.92003 10.6259 5.37336 9.08586 4.41336 7.19253L5.64669 5.95919C5.93336 5.67253 6.07336 5.27253 6.02669 4.86586L5.83336 3.18586C5.75336 2.51253 5.18669 2.00586 4.50669 2.00586H3.35336C2.60003 2.00586 1.97336 2.63253 2.02003 3.38586C2.37336 9.07919 6.92669 13.6259 12.6134 13.9792C13.3667 14.0259 13.9934 13.3992 13.9934 12.6459V11.4925C14 10.8192 13.4934 10.2525 12.82 10.1725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ab13fec1c4d535df7fc2a4af376ba149.svg";
export { ForwardRef as ReactComponent };